import classNames from 'classnames/bind'
import { imageLoader } from 'apps/main/libs/shared/util/imageLoader'
import Image from 'next/image'
import { Goal } from '@frontend-mono/shared/data-access-graphql'
import styles from './Goals.module.scss'

const cx = classNames.bind(styles)

type GoalsProps = {
  displayGoalTitle: string
  imageSource: string
  goals: Goal[]
}

const Goals = ({ displayGoalTitle, imageSource, goals }: GoalsProps) => {
  return (
    <div className={cx('container')}>
      <div className={cx('titleArea')}>
        <div className={cx('titleBox')}>
          <h1>{displayGoalTitle}</h1>
          <div className={cx('imageWrapper')}>
            <Image loader={imageLoader} src={imageSource} width={200} height={200} />
          </div>
        </div>
      </div>
      <ul className={cx('goals')}>
        {goals.map(({ title: goalTitle, description }) => (
          <li key={goalTitle} className={cx('goal')}>
            <h2>{goalTitle}</h2>
            <p>{description}</p>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Goals
